import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { loadSession, startSilentSessionRefresh } from "./core/auth";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";

(import.meta as any).env?.PROD
    ? setBasePath("/assets/shoelace")
    : setBasePath("/node_modules/@shoelace-style/shoelace/dist/");

import "./pages/app-home";
import "./components/header";
import "./styles/global.css";

@customElement("app-index")
export class AppIndex extends LitElement {
  @state() private ready = false;

  static styles = css`
    main {
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }
  `;

  async connectedCallback() {
      super.connectedCallback();

      const mod = await import("./core/router");
      const router = mod.router;

      // 🔥 FIX
      router.navigate(window.location.pathname);

      router.addEventListener("route-changed", () => {
        if ("startViewTransition" in document) {
          (document as any).startViewTransition(() => this.requestUpdate());
        } else {
          this.requestUpdate();
        }
      });

      try {
        await loadSession();
        startSilentSessionRefresh({ intervalMs: 60_000, immediate: false });
      } catch {}

      this.ready = true;
  }

  render() {
    if (!this.ready) {
      return html`
        <div style="padding:40px;font-weight:800">
          Initialisiere Sitzung …
        </div>
      `;
    }

    // @ts-ignore – router kommt aus dynamic import
    return (window as any).router?.render?.() ?? html``;
  }
}
